import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PreviousQuery } from "./SearchBar.components.js";
import Icon from "../../../components/atoms/Icon/index.js";
import Typography from "../../../components/atoms/Typography/index.js";
export const renderPreviousQuery = (item) => (_jsxs(PreviousQuery, { children: [_jsx(Icon, { type: "clock-rotate-left" }), " ", _jsx(Typography, { children: item.label })] }));
